import * as React from 'react';
import { IReportOption } from '../../data/providers/reports/reportOptions';
import { Entity, EntityType } from '../../data/types';
import { EPdfMode } from '../shared/pdf/Pdf';
import { AsymmetryReport } from './asymmetry/AsymmetryReport';
import { BlockReport } from './block/BlockReport';
import { ComparisonReport } from './comparison/ComparisonReport';
import { DsiReport } from './dsi/DsiReport';
import { EurReport } from './eur/EurReport';
import { ProfileReport } from './profile/ProfileReport';
import { QuadrantReport } from './quadrant/QuadrantReport';
import { RatioReport } from './ratio/RatioReport';
import { TrendReport } from './trend/TrendReport';
import { TsaReport } from './tsa/TsaReport';
import { WeightReport } from './weight/WeightReport';

interface IProps {
  report: IReportOption;
  entity: Entity;
  entityType: EntityType;
  pdfMode: EPdfMode;
  onPdfModeChange: (pdfMode: EPdfMode) => void;
  loading: boolean;
  setLoading: (v: boolean) => void;
}

/**
 * @description determines the correct report to render based on the supplied report option
 * @param props
 */
export const Reports = (props: IProps): React.ReactElement => {
  switch (props.report?.id) {
    case 'trend':
      return (
        <TrendReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    case 'profile':
      return (
        <ProfileReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    case 'comparison':
      return (
        <ComparisonReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    case 'dsi':
      return (
        <DsiReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    case 'eur':
      return (
        <EurReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    case 'ratio':
      return (
        <RatioReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    case 'block':
      return (
        <BlockReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    case 'weight':
      return (
        <WeightReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    case 'quadrant':
      return (
        <QuadrantReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    case 'tsa':
      return (
        <TsaReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    case 'asymmetry':
      return (
        <AsymmetryReport
          loading={props.loading}
          setLoading={props.setLoading}
          entity={props.entity}
          pdfMode={props.pdfMode}
          onPdfModeChange={props.onPdfModeChange}
          entityType={props.entityType}
        />
      );
    default:
      return null;
  }
};
